class SignupController {
  constructor(User, ngToast, $state) {
    "ngInject";
    this.name = 'signup';
    this.User = User;
    this.ngToast = ngToast;
    this.$state = $state;
    this.formData = {};
    let prefill_email = this.getParameterByName('prefill_email');
    if (prefill_email) {
      this.formData.email = prefill_email;
    }
  }


  signup(email, password) {
    this.loading = true;
    this.User.signup(email, password).then((data) => {
        console.log('signup sucessfull');
        this.loading = false;
        this.User.updateUserInFb();
        this.$state.go('onboarding.plans');
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
        this.showError(err.message);
      });
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  showError(err) {
    this.alert = {};
    this.alert = err;
  }

}

export default SignupController;



// WEBPACK FOOTER //
// ./client/app/components/auth/signup/signup.controller.js